import React, { useState, useEffect } from 'react';
import { User, Home, Trophy, Coins, Lock, Unlock, Zap, Star, Mail, ArrowRight, ShieldCheck } from 'lucide-react';
import LanguageSwitcher from './LanguageSwitcher';
import ResultBoard from './ResultBoard';
import GameCard from './GameCard';
import Profile from './Profile';
import confetti from 'canvas-confetti';
import { motion, AnimatePresence } from 'framer-motion';

const Dashboard = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoginView, setIsLoginView] = useState(true);
  const [lang, setLang] = useState('en');
  const [points, setPoints] = useState(1000);
  const [activeTab, setActiveTab] = useState('home');
  const [currentTime, setCurrentTime] = useState(new Date());
  const [winAnim, setWinAnim] = useState(false);
  const [showGuide, setShowGuide] = useState(false);
  const [regSuccess, setRegSuccess] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const getRoundStatus = (num) => {
    const startHour = 9 + num; 
    const openTime = new Date(); openTime.setHours(startHour, 0, 0);
    const duration = num === 10 ? 2 : 1;
    const closeTime = new Date(); closeTime.setHours(startHour + duration, 0, 0);
    if (currentTime >= openTime && currentTime < closeTime) return { status: 'LIVE', color: 'bg-green-600' };
    if (currentTime >= closeTime) return { status: 'CLOSED', color: 'bg-gray-600' };
    return { status: 'LOCKED', color: 'bg-red-600', time: `${startHour > 12 ? startHour - 12 : startHour}:00 ${startHour >= 12 ? 'PM' : 'AM'}` };
  };


  const handleWin = (amt) => {
    setWinAnim(true);
    setTimeout(() => { setPoints(p => p + amt); setWinAnim(false); }, 3000);
  };

  const onBetConfirm = async (betData) => {
    try {
      const response = await fetch('https://kolkatasuperb.com/api/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, email, password, phone, termsAccepted,
          userId: 1, 
          round: betData.round,
          number: betData.number,
          amount: betData.amount
        })
      });
      const data = await response.json();
    console.log("Server Response:", data);

    try {
    const response = await fetch('https://kolkatasuperb.com/api/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, email, password, phone, termsAccepted })
    });

    const data = await response.json();
    console.log("Server Response:", data);
    if (data.success) {
        
        setRegSuccess(true);
    } else {
        alert("Registration Failed: " + data.message);
    }
} catch (error) {
    console.error("Fetch Error:", error);
    alert("সার্ভারের সাথে কানেক্ট করা যাচ্ছে না। CORS বা ইন্টারনেট চেক করুন।");
}
      if (response.ok) {
          confetti({
                particleCount: 150,
                spread: 70,
                origin: { y: 0.6 },
                colors: ['#FFD700', '#FFA500', '#000080', '#00FF00']
                   });
                setTimeout(() => {
                setRegSuccess(false);
                setIsLoggedIn(true);
                setPoints(1000);
                setRegSuccess(true);
             }, 3000);     
             
             const [regSuccess, setRegSuccess] = useState(false); 
  const [isPolicyOpen, setIsPolicyOpen] = useState(false);
          
        setPoints(prev => prev - betData.amount);
        return true;
      }
    } catch (error) {
      console.error("Connection Failed:", error);
      return false;
    }
  };
  const [password, setPassword] = useState("");
  <input 
  type="password" 
  id="reg-password"
  name="password"
  placeholder="পাসওয়ার্ড দিন"
  value={password} 
  onChange={(e) => {
    console.log("Typing Password:", e.target.value); 
  }}
  className="your-style-classes"
  required 
/>
  
  if (!isLoggedIn) {
    return (
      <div className="min-h-screen bg-navy flex items-center justify-center p-6 font-sans">
        <div className="w-full max-w-md animate-in fade-in zoom-in duration-500">
          <div className="text-center mb-10">
            <h1 className="text-4xl font-black text-amazon-yellow italic tracking-tighter uppercase">Kolkata <span className="text-white">Super</span></h1>
            <p className="text-gray-400 text-[10px] font-bold mt-2 uppercase tracking-[0.3em]">Official Points Arena</p>
          </div>
          <div className="bg-white rounded-[3rem] p-8 shadow-2xl relative overflow-hidden border-b-8 border-amazon-yellow">
            <h2 className="text-2xl font-black text-navy mb-6 italic uppercase">{isLoginView ? 'Member Login' : 'Join Arena'}</h2>
            <div className="space-y-4">
              {!isLoginView && (
                <div className="relative">
                  <User className="absolute right-4 top-4 text-gray-300" size={20} />
                  <input type="text" placeholder="Full Name" className="w-full bg-bg-gray rounded-2xl py-4 px-6 font-bold text-navy outline-none border-2 border-transparent focus:border-amazon-yellow transition-all" />
                </div>
              )}
              
              <div className="relative">
                <Mail className="absolute right-4 top-4 text-gray-300" size={20} />
                <input type="email" placeholder="Email Address" className="w-full bg-bg-gray rounded-2xl py-4 px-6 font-bold text-navy outline-none border-2 border-transparent focus:border-amazon-yellow transition-all" />
              </div>
              <div className="relative">
                <Lock className="absolute right-4 top-4 text-gray-300" size={20} />
                <input type="password" placeholder="Password" className="w-full bg-bg-gray rounded-2xl py-4 px-6 font-bold text-navy outline-none border-2 border-transparent focus:border-amazon-yellow transition-all" />
              </div>

              <button onClick={() => setIsLoggedIn(true)} className="w-full bg-navy text-amazon-yellow py-4 rounded-2xl font-black flex items-center justify-center gap-2 hover:opacity-90 active:scale-95 transition-all shadow-xl mt-6 uppercase italic">
                {isLoginView ? 'Enter Arena' : 'Create Account'} <ArrowRight size={20} />
              </button>
            </div>
            <p className="mt-8 text-center text-sm font-bold text-gray-400">
              {isLoginView ? "New player?" : "Already a member?"} 
              <button onClick={() => setIsLoginView(!isLoginView)} className="ml-2 text-navy border-b-2 border-amazon-yellow">
                {isLoginView ? "Register Here" : "Login Here"}
              </button>
            </p>
          </div>
          <div className="mt-8 flex items-center justify-center gap-2 text-white/30 font-bold text-[9px] uppercase tracking-widest">
            <ShieldCheck size={14} /> Encrypted Point Protection System
          </div>
        </div>
      </div>
    );
  }
  
  <AnimatePresence>
  {regSuccess && (
    <motion.div 
      initial={{ opacity: 0, scale: 0.5, y: 50 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      exit={{ opacity: 0, scale: 0.5, y: -50 }}
      className="fixed inset-0 z-[200] flex items-center justify-center pointer-events-none"
    >
      <div className="bg-white p-8 rounded-3xl shadow-[0_20px_50px_rgba(0,0,0,0.3)] border-b-8 border-green-500 text-center">
        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-12 h-12 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7"></path>
          </svg>
        </div>
        <h2 className="text-3xl font-black text-navy mb-2">অভিনন্দন!</h2>
        <p className="text-gray-600 font-bold">রেজিস্ট্রেশন সফল হয়েছে।</p>
        <p className="text-orange font-black text-xl mt-2">+১০০০ বোনাস পয়েন্ট যোগ করা হয়েছে!</p>
      </div>
    </motion.div>
  )}
</AnimatePresence>

  const handleRegister = async () => {
    if(e) e.preventDefault();

    console.log("Final Data before Fetch:", { name, email, password, phone });
    const name = document.getElementById('reg-name').value;
    const email = document.getElementById('reg-email').value;
    const password = document.getElementById('reg-password').value;
    const phone = document.getElementById('reg-phone').value;
    const termsAccepted = document.getElementById('terms-checkbox').checked;

    if (!termsAccepted) {
        return alert("আপনাকে অবশ্যই আমাদের শর্তাবলী ও প্রাইভেসী পলিসি মেনে নিতে হবে।");
    }
    console.log("Data to be sent:", { name, email, password, phone, termsAccepted });

    try {
        const response = await fetch('https://kolkatasuperb.com/api/register', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 
                name: name, 
                email: email, 
                password: password, // পাসওয়ার্ড ফিল্ড
                phone: phone, 
                termsAccepted: true 
            })
        });
        const data = await response.json();
        console.log("Success:", data);
    } catch (err) {
        console.error("Error:", err);
    }
};

  // --- Main Dashboard View ---
  return (
    <div className="min-h-screen bg-bg-gray pb-24 font-sans selection:bg-orange/30 animate-in fade-in duration-700">
      {winAnim && (
        <div className="fixed inset-0 z-[200] flex items-center justify-center bg-navy/90 backdrop-blur-md">
          <div className="text-center animate-bounce text-white">
            <Star size={100} className="text-amazon-yellow mx-auto mb-4 fill-current" />
            <h2 className="text-6xl font-black italic uppercase">Jackpot!</h2>
            <p className="text-amazon-yellow text-2xl font-bold">+900 KPS Added</p>
          </div>
        </div>
      )}

      <header className="bg-navy sticky top-0 z-50 shadow-xl p-3 border-b border-white/10">
        <div className="container mx-auto flex justify-between items-center">
          <div className="flex items-center gap-3">
            {/* Home Icon Button - Clicking this takes you home */}
            <button 
              onClick={() => setActiveTab('home')}
              className="bg-white/10 p-2.5 rounded-2xl text-amazon-yellow border border-white/10 active:scale-90 transition-all"
            >
              <Home size={22} />
            </button>
            
            {/* Kolkata Super Text - Clicking this also takes you home */}
            <h1 
              onClick={() => setActiveTab('home')}
              className="text-2xl font-black text-amazon-yellow italic tracking-tighter uppercase cursor-pointer active:opacity-80 transition-all"
            >
              Kolkata <span className="text-white">Super</span>
            </h1>
          </div>

          <button onClick={() => console.log("Current State Password:", password)}>
  Check Password State
</button>

          <div className="flex items-center space-x-3">
            <button onClick={() => setActiveTab('profile')} className="bg-white/10 px-4 py-1.5 rounded-2xl border border-white/20 flex items-center active:scale-95 transition-all">
              <Coins size={18} className="text-amazon-yellow mr-2" />
              <span className="text-white font-black text-sm">{points} KPS</span>
            </button>
            <LanguageSwitcher setLang={setLang} currentLang={lang} />
          </div>
        </div>
      </header>
            
      <main className="container mx-auto p-4 max-w-7xl">
        {activeTab === 'home' ? (
          <div className="grid lg:grid-cols-12 gap-8">
            <div className="lg:col-span-8">
              <div className="mb-6 flex items-center justify-between bg-white p-5 rounded-[2rem] shadow-lg border border-amazon-border">
                <div className="flex items-center space-x-3 text-navy">
                  <div className="bg-navy/5 p-2 rounded-xl"><Zap className="text-orange" size={20} /></div>
                  <p className="font-black text-lg tracking-tight">{currentTime.toLocaleTimeString()}</p>
                </div>
                <div className="px-4 py-1 bg-green-100 text-green-600 rounded-full text-[10px] font-black tracking-widest">SYSTEM ONLINE</div>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                {[...Array(10)].map((_, i) => {
                  const info = getRoundStatus(i + 1);
                  const isLocked = info.status !== 'LIVE';
                  return (
                    <div key={i} className={`relative rounded-[2.5rem] overflow-hidden border-4 transition-all duration-500 ${!isLocked ? 'border-orange bg-white shadow-2xl scale-[1.02]' : 'border-transparent bg-white/50 opacity-60'}`}>
                      <div className={`${info.color} py-2 text-center text-[10px] font-black text-white tracking-widest flex justify-center items-center gap-2 uppercase`}>
                        {isLocked ? <Lock size={12}/> : <Unlock size={12} className="animate-pulse" />}
                        {info.status === 'LOCKED' ? `Starts at ${info.time}` : `${info.status} Round ${i+1}`}
                      </div>
                      <div className={`p-2 ${isLocked ? 'grayscale pointer-events-none' : ''}`}>
                        <GameCard round={i + 1} lang={lang} onWin={() => handleWin(900)} />
                      </div>
                    </div>
                  );
                  if (showGuide) {
                      return <GuidePage onClose={closeGuide} />;
                    }
                })}
              </div>
            </div>
            <div className="lg:col-span-4 space-y-6"><ResultBoard lang={lang} /></div>
          </div>
        ) : <Profile points={points} setActiveTab={setActiveTab} />}
      </main>

      <footer className="fixed bottom-14 left-0 right-0 bg-black text-amazon-yellow py-1.5 overflow-hidden z-40 border-y border-white/10 shadow-2xl">
        <div className="whitespace-nowrap animate-marquee flex items-center italic">
          <span className="mx-8 font-black uppercase text-[11px] tracking-wider">⚠️ POINT SYSTEM: Use your daily bonus KPS to play. 10th Round gives 90x points! No real money required.It is not financially sound. It should be used only for the welfare of the people and not for any monetary gain. ⚠️</span>
          <span className="mx-8 font-black uppercase text-[11px] tracking-wider">⚠️ POINT SYSTEM: Use your daily bonus KPS to play. 10th Round gives 90x points! No real money required. It is not financially sound. It should be used only for the welfare of the people and not for any monetary gain. ⚠️</span>
        </div>
      </footer>

      <nav className="fixed bottom-0 left-0 right-0 bg-white border-t flex justify-around p-3 z-50 md:hidden shadow-2xl rounded-t-[1.5rem]">
        <button onClick={() => setActiveTab('home')} className={`flex flex-col items-center ${activeTab === 'home' ? 'text-orange' : 'text-gray-400'}`}>
          <Home size={22} /><span className="text-[10px] font-black mt-1 uppercase">Games</span>
        </button>
        <button onClick={() => setActiveTab('profile')} className={`flex flex-col items-center group ${activeTab === 'profile' ? 'text-orange' : 'text-gray-400'}`}>
          <div className={`p-2 rounded-full -mt-8 border-4 border-bg-gray transition-all ${activeTab === 'profile' ? 'bg-navy text-amazon-yellow shadow-lg' : 'bg-gray-200'}`}>
            <User size={24} />
          </div>
          <span className="text-[10px] font-black mt-1 uppercase">Profile</span>
        </button>
      </nav>

      <style>{`
        @keyframes marquee { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }
        .animate-marquee { display: inline-block; animation: marquee 15s linear infinite; }
      `}</style>
    </div>
  );
};

export default Dashboard;